import BoostPassiveAbstractStore from "./BoostPassiveAbstractStore";

export default class BoostMaxSizeStore extends BoostPassiveAbstractStore {}
